import React, { useState, useEffect } from "react";

const SettingTab = ({ updateWhatsAppTabData, whatsAppTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [activeSettingElementsMainSubTab, setActiveSettingElementsMainSubTab] = useState("main_sub");
    const [activeAlignmentSection, setActiveAlignmentSection] = useState(whatsAppTabData.setting_position_alignment_type);
    const [displayChatPageType, setDisplayChatPageType] = useState(whatsAppTabData.setting_chat_display_pages_type);
    const [selectedDevices, setSelectedDevices] = useState(whatsAppTabData.setting_chat_display_devices || []);
    const [displayChatFor, setDisplayChatFor] = useState(whatsAppTabData.setting_chat_display_visitors_type);
    const [selectedWhentoDisplayChat, setSelectedWhentoDisplayChat] = useState(whatsAppTabData.setting_chat_display_date_time_display_chat_days || []);
    const [showShowTimeSchedule, setShowTimeSchedule] = useState(Number(whatsAppTabData.setting_chat_display_date_time_is_time_schedule));
    const [showShowOnPageLoad, setShowOnPageLoad] = useState(Number(whatsAppTabData.setting_open_chat_triggers_is_on_page_load));
    const [showShowExitIntent, setShowExitIntent] = useState(Number(whatsAppTabData.setting_open_chat_triggers_is_exit_intent));
    const [bubbleNotificationBadge, setBubbleNotificationBadge] = useState(Number(whatsAppTabData.setting_notifications_bubble_notification_badge));

    //Remember Visitor Day
    const [selectedRememberVisitorDay, setSelectedRememberVisitorDay] = useState(whatsAppTabData.setting_open_chat_triggers_remembers_visitors);
    const [showRememberVisitorDropdown, setShowRememberVisitorDropdown] = useState(false);
    const layoutRememberVisitorValues = ['1 Day', '2 Days', '3 Days', '4 Days', '5 Days', '6 Days', '1 Week', '2 Weeks', '1 Month'];
    const toggleRememberVisitorDropdown = () => {
        setShowRememberVisitorDropdown(!showRememberVisitorDropdown);
    };
    const handleRememberVisitorSelect = (spacing) => {
        setSelectedRememberVisitorDay(spacing);
        setShowRememberVisitorDropdown(false);
        updateWhatsAppTabData("setting_open_chat_triggers_remembers_visitors", spacing);
    };

    //Time Schedule Start Time
    const [selectedSTartTimeTimeSchedule, setSelectedSTartTimeTimeSchedule] = useState(whatsAppTabData.setting_chat_display_date_time_start_time);
    const [showSTartTimeTimeScheduleDropdown, setShowSTartTimeTimeScheduleDropdown] = useState(false);
    const layoutSTartTimeTimeScheduleValues = ['12:00 AM', '1:00 AM','2:00 AM','3:00 AM','4:00 AM','5:00 AM','6:00 AM','7:00 AM','8:00 AM','9:00 AM','10:00 AM','11:00 AM'];
    const toggleSTartTimeTimeScheduleDropdown = () => {
        setShowSTartTimeTimeScheduleDropdown(!showSTartTimeTimeScheduleDropdown);
    };
    const handleSTartTimeTimeScheduleSelect = (spacing) => {
        setSelectedSTartTimeTimeSchedule(spacing);
        setShowSTartTimeTimeScheduleDropdown(false);
        updateWhatsAppTabData("setting_chat_display_date_time_start_time", spacing);
    };

    //Time Schedule End Time
    const [selectedEndTimeTimeSchedule, setSelectedEndTimeTimeSchedule] = useState(whatsAppTabData.setting_chat_display_date_time_end_time);
    const [showEndTimeTimeScheduleDropdown, setShowEndTimeTimeScheduleDropdown] = useState(false);
    const layoutEndTimeTimeScheduleValues = ['12:00 AM', '1:00 AM','2:00 AM','3:00 AM','4:00 AM','5:00 AM','6:00 AM','7:00 AM','8:00 AM','9:00 AM','10:00 AM','11:00 AM'];
    const toggleEndTimeTimeScheduleDropdown = () => {
        setShowEndTimeTimeScheduleDropdown(!showEndTimeTimeScheduleDropdown);
    };
    const handleEndTimeTimeScheduleSelect = (spacing) => {
        setSelectedEndTimeTimeSchedule(spacing);
        setShowEndTimeTimeScheduleDropdown(false);
        updateWhatsAppTabData("setting_chat_display_date_time_end_time", spacing);
    };

    // Handle Source Tab input change
    const handleActiveAlignmentInputChange = (event) => {
        setActiveAlignmentSection(event.target.value);
        updateWhatsAppTabData("setting_position_alignment_type", event.target.value);
    };

    // Handlers Where to Display Chat Change
    const handleDisplayChatPageTypeChange = (event) => {
        const value = event.target.value;
        setDisplayChatPageType(value);
        updateWhatsAppTabData("setting_chat_display_pages_type", value);
    };

    // UseEffect Display Chat on Devices Change
    useEffect(() => {
        // Sync state if whatsAppTabData updates from outside
        if (Array.isArray(whatsAppTabData.setting_chat_display_devices)) {
          setSelectedDevices(whatsAppTabData.setting_chat_display_devices);
        } else if (typeof whatsAppTabData.setting_chat_display_devices === 'string') {
          try {
            const parsed = JSON.parse(whatsAppTabData.setting_chat_display_devices);
            setSelectedDevices(parsed);
          } catch (e) {
            // Fallback if not a valid JSON string
            const devicesFromString = whatsAppTabData.setting_chat_display_devices.split(',').map(item => item.trim());
            setSelectedDevices(devicesFromString);
          }
        }
    }, [whatsAppTabData.setting_chat_display_devices]); 

    // Handlers Display Chat on Devices Change
    const handleDeviceChange = (event) => {
        const { value, checked } = event.target;
        let updatedDevices = [...selectedDevices];
    
        if (checked) {
          if (!updatedDevices.includes(value)) {
            updatedDevices.push(value);
          }
        } else {
          updatedDevices = updatedDevices.filter(device => device !== value);
        }
    
        setSelectedDevices(updatedDevices);
        updateWhatsAppTabData("setting_chat_display_devices", JSON.stringify(updatedDevices));
    };

    // UseEffect When to Display Chat  Change
    useEffect(() => {
        // Sync state if whatsAppTabData updates from outside
        if (Array.isArray(whatsAppTabData.setting_chat_display_date_time_display_chat_days)) {
            setSelectedWhentoDisplayChat(whatsAppTabData.setting_chat_display_date_time_display_chat_days);
        } else if (typeof whatsAppTabData.setting_chat_display_date_time_display_chat_days === 'string') {
          try {
            const days_parsed = JSON.parse(whatsAppTabData.setting_chat_display_date_time_display_chat_days);
            setSelectedWhentoDisplayChat(days_parsed);
          } catch (e) {
            // Fallback if not a valid JSON string
            const daysFromString = whatsAppTabData.setting_chat_display_date_time_display_chat_days.split(',').map(item => item.trim());
            setSelectedWhentoDisplayChat(daysFromString);
          }
        }
    }, [whatsAppTabData.setting_chat_display_date_time_display_chat_days]); 

    // Handlers When to Display Chat Change
    const handleWhentoDisplayChatChange = (event) => {
        const { value, checked } = event.target;
        let updatedWhentoDisplayChat = [...selectedWhentoDisplayChat];
    
        if (checked) {
          if (!updatedWhentoDisplayChat.includes(value)) {
            updatedWhentoDisplayChat.push(value);
          }
        } else {
            updatedWhentoDisplayChat = updatedWhentoDisplayChat.filter(device => device !== value);
        }
    
        setSelectedWhentoDisplayChat(updatedWhentoDisplayChat);
        updateWhatsAppTabData("setting_chat_display_date_time_display_chat_days", JSON.stringify(updatedWhentoDisplayChat));
    };

     // Handlers Display Chat For Change
     const handleDisplayChatForChange = (event) => {
        const value = event.target.value;
        setDisplayChatFor(value);
        updateWhatsAppTabData("setting_chat_display_visitors_type", value);
    };

    // Handlers Show Time Schedule Change
    const handleShowTimeScheduleChange = (e) => {
        const checked = e.target.checked;
        setShowTimeSchedule(checked);
        updateWhatsAppTabData("setting_chat_display_date_time_is_time_schedule", checked); 
    };

    // Handlers Show On Page Load Change
    const handleShowOnPageLoadChange = (e) => {
        const checked = e.target.checked;
        setShowOnPageLoad(checked);
        updateWhatsAppTabData("setting_open_chat_triggers_is_on_page_load", checked); 
    };

    // Handlers Show Exit Intent Change
    const handleShowExitIntentChange = (e) => {
        const checked = e.target.checked;
        setShowExitIntent(checked);
        updateWhatsAppTabData("setting_open_chat_triggers_is_exit_intent", checked); 
    };

    // Handlers Bubble notification badge Change
    const handleBubbleNotificationBadgeChange = (e) => {
        const checked = e.target.checked;
        setBubbleNotificationBadge(checked);
        updateWhatsAppTabData("setting_notifications_bubble_notification_badge", checked); 
    };

    return (
        <div className="whats-app-side-baar-setting-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Setting</span>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("position")}>Position <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("chat_display")}>Chat Display Settings <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("open_chat")}>Open Chat Triggers <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("notification")}>Notifications <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "position" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Position</span>
                        <div className="side-baar-box-header">
                            {/*<div className="box-header-row">
                                <p>Position</p>
                                <ul>
                                    <li>
                                        <div className="form-group">
                                            <input type="radio" id="test1" value="Floating Bubble" name="radio-group" ref={enablePositionRef} onChange={handleEnablePositionRef} defaultChecked={true} />
                                            <label for="test1">Floating Bubble</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input type="radio" id="test2" value="Embed Bubble" name="radio-group" ref={enablePositionRef} onChange={handleEnablePositionRef} defaultChecked={true} />
                                            <label for="test2">Embed Bubble</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input type="radio" id="test3" value="Embed Chat Window" name="radio-group" ref={enablePositionRef} onChange={handleEnablePositionRef} defaultChecked={true} />
                                            <label for="test3">Embed Chat Window</label>
                                        </div>
                                    </li>
                                </ul>
                            </div>*/}
                        </div>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <p>Alignment</p>
                                <div className="left-cnater-right-button">
                                    <label className="card-radio-btn">
                                        <input type="radio" name="alignment_type" className="card-input-element d-none" value="left-side" onChange={handleActiveAlignmentInputChange} checked={activeAlignmentSection === "left-side"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Left</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="alignment_type" className="card-input-element d-none" value="center-side" onChange={handleActiveAlignmentInputChange} checked={activeAlignmentSection === "center-side"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Center</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="alignment_type" className="card-input-element d-none" value="right-side" onChange={handleActiveAlignmentInputChange} checked={activeAlignmentSection === "right-side"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Right</div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                            {/*<div className="box-header-row">
                                <span>Vertical Offset</span>
                                <em>20px</em>
                                <div className="slider-container">
                                    <input min="20" max="20" type="range" value="20" wfd-id="id8" />
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Horizontal Offset</span>
                                <em>20px</em>
                                <div className="slider-container">
                                    <input min="20" max="20" type="range" value="20" wfd-id="id8" />
                                </div>
                            </div>*/}
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "chat_display" && (
                <div className="inner-box-layout">
                    {activeSettingElementsMainSubTab === "main_sub" && (
                        <>
                            <span>
                                <button onClick={() => setActiveSettingElementsTab("main")}>
                                    <i className="fa fa-angle-left" aria-hidden="true"></i> Back
                                </button>
                                Chat Display
                            </span>
                            <div className="customize-elements-list">
                                <ul>
                                    <li><button onClick={() => setActiveSettingElementsMainSubTab("chat_display_pages")}>Pages <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                                    <li><button onClick={() => setActiveSettingElementsMainSubTab("chat_display_devices")}>Devices <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                                    <li><button onClick={() => setActiveSettingElementsMainSubTab("chat_display_visitors")}>Visitors <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                                    <li><button onClick={() => setActiveSettingElementsMainSubTab("chat_display_date_time")}>Date & Time <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                                </ul>
                            </div>
                            <p>The settings above are used to activate/deactivate the widget depending on specific parameters.</p>
                        </>
                    )}

                    {activeSettingElementsMainSubTab === "chat_display_pages" && (
                        <>
                            <span>
                                <button onClick={() => setActiveSettingElementsMainSubTab("main_sub")}>
                                    <i className="fa fa-angle-left" aria-hidden="true"></i> Back
                                </button>
                                Pages
                            </span>
                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <h6 className="h6-tage">Where to Display Chat</h6>
                                    <ul className="pages-list-two">
                                        <li>
                                            <div className="form-group">
                                                <input id="test1" type="radio" name="radio-group" value="All_Pages" onChange={handleDisplayChatPageTypeChange} checked={displayChatPageType === 'All_Pages'} />
                                                <label for="test1">All Pages</label>
                                            </div>
                                        </li>
                                        {/*<li>
                                            <div className="form-group">
                                                <input id="test2" type="radio" name="radio-group" value="Exclude_Pages" onChange={handleDisplayChatPageTypeChange} checked={displayChatPageType === 'Exclude_Pages'}/>
                                                <label for="test2">Exclude Pages</label>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="form-group">
                                                <input id="test3" type="radio" name="radio-group" value="Specific_Pages" onChange={handleDisplayChatPageTypeChange} checked={displayChatPageType === 'Specific_Pages'} />
                                                <label for="test3">Specific Pages</label>
                                            </div>
                                        </li>*/}
                                    </ul>
                                </div>
                            </div>
                            <p>This setting is used in case you've installed the chat to your website template, and it's available on each page of your website.</p>
                        </>
                    )}

                    {activeSettingElementsMainSubTab === "chat_display_devices" && (
                        <>
                            <span>
                                <button onClick={() => setActiveSettingElementsMainSubTab("main_sub")}>
                                    <i className="fa fa-angle-left" aria-hidden="true"></i> Back
                                </button>
                                Devices
                            </span>
                                <div className="side-baar-box-header">
                                    <div className="box-header-row">
                                        <h6 className="h6-tage">Display Chat on</h6>
                                        <ul className="pages-list-two">
                                            <li>
                                                <div className="form-group">
                                                    <input id="mobile_devices" type="checkbox" value="Mobile Devices" checked={selectedDevices.includes("Mobile Devices")} onChange={handleDeviceChange} />
                                                    <label for="mobile_devices">Mobile Devices</label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="form-group">
                                                    <input id="desktop_devices" type="checkbox" value="Desktop" checked={selectedDevices.includes("Desktop")} onChange={handleDeviceChange} />
                                                    <label for="desktop_devices">Desktop</label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                        </>
                    )}

                    {activeSettingElementsMainSubTab === "chat_display_visitors" && (
                        <>
                            <span>
                                <button onClick={() => setActiveSettingElementsMainSubTab("main_sub")}>
                                    <i className="fa fa-angle-left" aria-hidden="true"></i> Back
                                </button>
                                Visitors
                            </span>
                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <h6 className="h6-tage">Display Chat for</h6>
                                    <ul className="pages-list-two">
                                        <li>
                                            <div className="form-group">
                                                <input id="all_visitors" type="radio" value="All_Visitors" onChange={handleDisplayChatForChange} checked={displayChatFor === 'All_Visitors'} />
                                                <label for="all_visitors">All Visitors</label>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="form-group">
                                                <input id="new_visitors" type="radio" value="New_Visitors" onChange={handleDisplayChatForChange} checked={displayChatFor === 'New_Visitors'}/>
                                                <label for="new_visitors">New Visitors</label>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="form-group">
                                                <input id="returning_visitors" type="radio" value="Returning_Visitors" onChange={handleDisplayChatForChange} checked={displayChatFor === 'Returning_Visitors'} />
                                                <label for="returning_visitors">Returning Visitors</label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <p>Select the category of visitors you want to display the chat for: all visitors, visitors who have come to your website for the first time, visitors who had been on your website before.</p>
                        </>
                    )}

                    {activeSettingElementsMainSubTab === "chat_display_date_time" && (
                        <>
                            <span>
                                <button onClick={() => setActiveSettingElementsMainSubTab("main_sub")}>
                                    <i className="fa fa-angle-left" aria-hidden="true"></i> Back
                                </button>
                                Date & Time
                            </span>
                            <div className="side-baar-box-header">
                            <div className="box-header-row">
                            <h6 className="h6-tage">When to Display Chat</h6>
                                <ul>
                                    <li>
                                        <div className="form-group">
                                            <input id="chat_monday" type="checkbox" value="Monday" checked={selectedWhentoDisplayChat.includes("Monday")} onChange={handleWhentoDisplayChatChange} />
                                            <label for="chat_monday">Monday</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="chat_tuesday" type="checkbox" value="Tuesday" checked={selectedWhentoDisplayChat.includes("Tuesday")} onChange={handleWhentoDisplayChatChange} />
                                            <label for="chat_tuesday">Tuesday</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="chat_wednesday" type="checkbox" value="Wednesday" checked={selectedWhentoDisplayChat.includes("Wednesday")} onChange={handleWhentoDisplayChatChange} />
                                            <label for="chat_wednesday">Wednesday</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="chat_thursday" type="checkbox" value="Thursday" checked={selectedWhentoDisplayChat.includes("Thursday")} onChange={handleWhentoDisplayChatChange}/>
                                            <label for="chat_thursday">Thursday</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="chat_friday" type="checkbox" value="Friday" checked={selectedWhentoDisplayChat.includes("Friday")} onChange={handleWhentoDisplayChatChange} />
                                            <label for="chat_friday">Friday</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="chat_saturday" type="checkbox" value="Saturday" checked={selectedWhentoDisplayChat.includes("Saturday")} onChange={handleWhentoDisplayChatChange} />
                                            <label for="chat_saturday">Saturday</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="chat_sunday" type="checkbox" value="Sunday" checked={selectedWhentoDisplayChat.includes("Sunday")} onChange={handleWhentoDisplayChatChange} />
                                            <label for="chat_sunday">Sunday</label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="side-baar-box-header">
                            <div className="box-header-row last-border-none"><span>Set the Time Schedule</span>
                                <div className="form-group">
                                    <input id="time_schedule_toggle" className="chkbx-toggle" type="checkbox" checked={showShowTimeSchedule} onChange={handleShowTimeScheduleChange}/>
                                    <label for="time_schedule_toggle"></label>
                                </div>
                            </div>
                        </div>
                        {Number(whatsAppTabData.setting_chat_display_date_time_is_time_schedule) === 1 && (
                            <>
                                <div className="box-header-row">
                                    <span>Start Time</span>
                                    <em onClick={toggleSTartTimeTimeScheduleDropdown}>{selectedSTartTimeTimeSchedule}</em>
                                    {showSTartTimeTimeScheduleDropdown && (
                                        <ul className="dropdown-list">
                                            {layoutSTartTimeTimeScheduleValues.map((spacing) => (
                                                <li key={spacing} onClick={() => handleSTartTimeTimeScheduleSelect(spacing)}>
                                                    {spacing}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                                <div className="box-header-row">
                                    <span>End Time</span>
                                    <em onClick={toggleEndTimeTimeScheduleDropdown}>{selectedEndTimeTimeSchedule}</em>
                                    {showEndTimeTimeScheduleDropdown && (
                                        <ul className="dropdown-list">
                                            {layoutEndTimeTimeScheduleValues.map((spacing) => (
                                                <li key={spacing} onClick={() => handleEndTimeTimeScheduleSelect(spacing)}>
                                                    {spacing}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </>
                        )}
                        </>
                    )}
                </div>
            )}

            {activeSettingElementsTab === "open_chat" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Open Chat Triggers</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>On Page Load</span>
                                <div className="form-group">
                                    <input id="open_chat_on_page_load_toggle" className="chkbx-toggle" type="checkbox" checked={showShowOnPageLoad} onChange={handleShowOnPageLoadChange} />
                                    <label for="open_chat_on_page_load_toggle"></label>
                                </div>
                            </div>
                            {/*<div className="box-header-row">
                                <span>Time on Page</span>
                                <em>0s</em>
                            </div>
                            <div className="box-header-row">
                                <span>Time on Site</span>
                                <em>0s</em>
                            </div>
                            <div className="box-header-row">
                                <span>Scroll Position</span>
                                <em>0%</em>
                            </div>*/}
                            <div className="box-header-row">
                                <span>Exit Intent</span>
                                <div className="form-group">
                                    <input id="chat_triger_exit_intent_toggle" className="chkbx-toggle" type="checkbox" checked={showShowExitIntent} onChange={handleShowExitIntentChange}/>
                                    <label for="chat_triger_exit_intent_toggle"></label>
                                </div>
                            </div>
                        </div>
                        <p>Here you can set the type of user behavior that will open the chat window automatically.</p>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Remember Visitor</span>
                                <em onClick={toggleRememberVisitorDropdown}>{selectedRememberVisitorDay}</em>
                                {showRememberVisitorDropdown && (
                                    <ul className="dropdown-list">
                                        {layoutRememberVisitorValues.map((spacing) => (
                                            <li key={spacing} onClick={() => handleRememberVisitorSelect(spacing)}>
                                                {spacing}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <p>Don’t open the chat window again for a certain time period if the visitor closed it.</p>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "notification" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Notifications</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <ul className="notifaction-tabe">
                                    <li>
                                        <div className="form-group">
                                            <input id="test-1" type="checkbox" value="1" checked={bubbleNotificationBadge} onChange={handleBubbleNotificationBadgeChange} />
                                            <label for="test-1">Bubble notification badge</label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default SettingTab;